import clsx from "clsx";
import React from "react";
import { PointIcon } from "../svg/GeneralIcons";

function Points({ userPoints, className, textClass }) {
  return (
    <div
      className={clsx(
        "px-2 py-1 h-[36px] justify-between rounded-full flex items-center gap-1",
        className
      )}
    >
      <PointIcon />
      <p className={clsx("text-[11px] font-semibold text-white", textClass)}>
        {userPoints}
      </p>
    </div>
  );
}

export default Points;
